import React from 'react';
//numeric input
import NumericInput from 'react-numeric-input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class BidRoundInput extends React.Component {

  render(){
    return(
      <div className='row'>
        <div className='col-lg-2'>
          <div>
            <FontAwesomeIcon
              icon={['fad', 'layer-group']}
              mask={['fas', 'circle']}
              size='4x'
              transform='shrink-6'
              color='#4CABA9'
              style={{ marginTop: '5px' }}
            />
          </div>
        </div>
        <div className='col-lg-10'>
          <b>{this.props.fieldAlias}</b>
          <NumericInput
            onChange={(e) => this.props.handleFormChange(this.props.formField, e)}
            className='form-control'
            name='roundInput'
            min={1}
            placeholder={this.props.placeholder}
          />
        </div>
      </div>
    )//end return
  }//end render

}//end class

export default BidRoundInput;
